import styles from "./addNotification.module.css";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import { Autocomplete, FormControl, IconButton, InputLabel, MenuItem, Select, Slide, Snackbar, TextField, Typography } from "@mui/material";
import { ArrowLeft, Home, X } from "react-feather";
import { Editor } from "@tinymce/tinymce-react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from 'react-smart-toaster';
import Loader from "../../components/Loader";

const schema = yup.object().shape({
  type: yup.string().required("This field is Required"),
  category: yup.string().required("This field is Required"),
  subject: yup.string().required("This field is Required"),
  content: yup.string().required("This field is Required"),
});

const AddEmailTemplate = ({ history, match }) => {
  const { getAccessTokenSilently } = useAuth0();
  const redirect = useHistory();
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const editorRef = useRef(null);
  const { id } = match.params;
  const isAddMode = !id;

  useEffect(() => {
    const geNotificationList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/email-sms-category", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setCategoryList(response.data.data);
      }).catch(() => { });
    }

    geNotificationList();
  }, [getAccessTokenSilently]);

  const { errors, control, handleSubmit, setValue, clearErrors } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      type: '',
      category: '',
      subject: '',
      content: ''
    }
  });

  useEffect(() => {
    async function fetchData() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      axios.get(process.env.REACT_APP_USER_API_URL + "v1/email-sms-contents/" + id, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setValue("type", response.data.data?.type);
        setValue("category", response.data.data?.category);
        setValue("subject", response.data.data?.subject);
        setValue("content", response.data.data?.content);
      }).catch((error) => { });
    }

    if (id) {
      fetchData();
    }
  }, [id, getAccessTokenSilently, setValue]);

  const onSubmit = async (data) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    if (data?.logo_type === '')
      delete data?.logo_type;

    axios.post(process.env.REACT_APP_USER_API_URL + "v1/email-sms-contents", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarMsg("Notification added successfully.");
      setSnackbarOpen(true);

      setTimeout(() => {
        redirect.push('/notification/email-sms-notification');
      }, 2000);

    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const onUpdate = async (data) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    if (data?.logo_type === '')
      delete data?.logo_type;

    axios.post(process.env.REACT_APP_USER_API_URL + "v1/email-sms-contents/" + id, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarMsg("Notification updated successfully.");
      setSnackbarOpen(true);

      setTimeout(() => {
        redirect.push('/notification/email-sms-notification');
      }, 2000);

    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<>
    <Helmet title="Add Notification" />

    {loading && <Loader />}

    <div className={`${styles.mainCard}`}>
      <div className={`${styles.SMProCusRow}`}>
        <div className={`${styles.BreadcrumbHeadSec}`}>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Notification</li>
              <li className={`${styles.breadcrumbItem}`}>
                <Link to={"/notification/email-sms-notification"}>Manage Notification</Link>
              </li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>{isAddMode ? 'Add Notification' : 'Edit Notification'}</li>
            </ol>
          </nav>
          <div className={`${styles.PageTitleSec}`}>
            <div>
              <Link to={`/notification/email-sms-notification`} className={`${styles.BackArrow}`}>
                <ArrowLeft />
              </Link>
              <Typography display="inline" className={`${styles.pageTitle}`}>{isAddMode ? 'Add Notification' : 'Edit Notification'}</Typography>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit(isAddMode ? onSubmit : onUpdate)}>
          <div className={`${styles.EmailTemplateBodySec}`}>
            <div className={`${styles.AddLeaseSection}`}>
              <div className={`${styles.AddDocTitleSec}`}>
                <div className={`${styles.FormGroupAddLeaseType} FormGroup`}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                    <Controller
                      name="type"
                      control={control}
                      render={(field) => (<Select
                        {...field}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Type"
                        onChange={(e) => {
                          field.onChange(e);
                          setSelectedType(e.target.value);

                          setValue('category', '');
                          clearErrors();
                        }}
                      >
                        <MenuItem value="Email">Email</MenuItem>
                        <MenuItem value="SMS">SMS</MenuItem>
                      </Select>)}
                    />
                    {errors?.type && (<p className={`${styles.ErrorM}`}>{errors?.type?.message}</p>)}
                  </FormControl>
                </div>
                <div className={`${styles.FormGroupAddLease} FormGroup`}>
                  <Controller
                    name={`category`}
                    control={control}
                    render={(field) => (<Autocomplete
                      value={field?.value ? field?.value : ""}
                      disableClearable
                      openOnFocus
                      freeSolo
                      options={selectedType !== '' ? categoryList?.filter(i => i?.type === selectedType) : [{ label: 'Select type first', is_disabled: 1 }]}
                      getOptionDisabled={(option) => parseInt(option?.is_disabled) > 0}
                      onChange={(event, newValue) => {
                        console.log('newValue');
                        console.log(newValue);

                        setValue('category', newValue?.label);
                        clearErrors();
                      }}
                      onInputChange={(event, newInputValue) => {
                        console.log('newInputValue');
                        console.log(newInputValue);

                        setValue('category', newInputValue);
                        clearErrors();
                      }}
                      renderInput={(params) => <TextField {...params} label="Title" />}
                    />)}
                  />
                  {errors.category && (<p className={`${styles.ErrorM}`}>{errors?.category?.message}</p>)}
                </div>
                <div className={`${styles.FormGroupAddLeaseFull} FormGroup`}>
                  <Controller
                    name="subject"
                    control={control}
                    render={(field) => (<TextField {...field} id="outlined-basic" label="Subject" variant="outlined" />)}
                  />
                  {errors.subject && (<p className={`${styles.ErrorM}`}>{errors?.subject?.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormGroupTextareaFull}`}>
                <label className={`${styles.FilterLabel}`}>
                  Description<span className={`${styles.errorSpan}`}>*</span>
                </label>
                <Controller
                  name="content"
                  control={control}
                  render={(field) => (
                    <Editor
                      onInit={(evt, editor) => { editorRef.current = editor }}
                      className={`${styles.formControlTextArea}`}
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      value={field?.value}
                      init={{
                        height: 500,
                        menubar: false,
                        plugins: ["lists", "code", "table", "media", "image"],
                        toolbar: ["undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor removeformat | alignleft aligncenter alignright alignjustify | numlist bullist | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | image | code"],
                      }}
                      onEditorChange={(e) => field.onChange(e)}
                    />
                  )}
                />
                {errors.content && (<p className={`${styles.ErrorM}`}>{errors.content.message}</p>)}
              </div>
              <div className={`${styles.ButtonAction}`}>
                <button className={`${styles.CancelPopupBU}`} type="button" onClick={(e) => redirect.push("/notification/email-sms-notification")}>Cancel</button>
                <button className={`${styles.SubmitPopupBU}`} type="submit">{isAddMode ? 'Add' : 'Update'}</button>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>)
}

export default withAuthenticationRequired(AddEmailTemplate, {
  onRedirecting: () => <Loader />,
});
